import React from "react";
import "../home-page/HomePage.css";
import LabelMain from "./LabelMain";
export default function LabelPage() {
  return (
    <div className="typora-container">
      <LabelMain />
    </div>
  );
}
